var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-0"},[_c('v-card',{staticClass:"plan-list-card",attrs:{"flat":""}},[_c('travel-plan-list',{attrs:{"is-inspiration":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }